import { createStore } from "vuex";
const store = createStore({
  // state, 状态
  // mutations, 同步修改状态的函数
  // actions, 异步修改状态函数
  // getters, 处理数据
  state: {
    resName: "cc咖啡馆",
    resName4: "cc咖啡馆",
    Name: "文昊",
    w1: [],
    Img1: "./assets/downThItemL.png",
    w2: [],
    W2Title: "",
    Img2: "./assets/downThItemL.png",
  },
  mutations: {
    setResName: (state, payload) => {
      // sate对象就对应了sate.js中的对象
      // payload载荷 对应的 传递的 josn对象参数(name:zs,age:12)
      state.resName = payload.resName;
    },
    setName: (state, payload) => {
      state.Name = payload.Name;
    },
    //  1
    setW1: (state, payload) => {
      state.w1 = payload.w1;
    },
    setImg1: (state, payload) => {
      state.Img1 = payload.Img1;
    },

    // 2
    setW2: (state, payload) => {
      state.w2 = payload.w2;
    },
    setW2Title: (state, payload) => {
      state.W2Title = payload.w2Title;
    },
  },
  actions: {
    setResNameAsync: (context, payload) => {
      // 异步修改值 在异步方法中调用了同步方法
      //  context指的是Vuex的上下文，相当于 this.$store
      // 死代码，6秒后执行
      setTimeout(function () {
        context.commit("setResName", payload);
      }, 6000);

      let _this = payload._this;
      let url = _this.axios.urls.SYSTEM_MENU_TREE;
      _this.axios.post(url, {}).then((r) => {
      }).catch((e) => { });
    },
  },
  getters: {
    getResName: (state) => {
      /* 这里的sate代表的是sate.js整个文件 */
      return state.resName;
    },
    getName: (state) => {
      return state.Name;
    },
    getW1: (state) => {

      return state.w1;
    },
    getImg1: (state) => {
      return state.Img1;
    },
    // weektwo2
    getW2: (state) => {
      return state.w2;
    },
    getW2Title: (state) => {
      return state.w2Title;
    },
  }
});
export default store;
